import { render, staticRenderFns } from "./zhifubaoQRCode.vue?vue&type=template&id=50b4ecfb&scoped=true&"
import script from "./zhifubaoQRCode.vue?vue&type=script&lang=js&"
export * from "./zhifubaoQRCode.vue?vue&type=script&lang=js&"
import style0 from "./zhifubaoQRCode.vue?vue&type=style&index=0&id=50b4ecfb&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "50b4ecfb",
  null
  
)

export default component.exports